module.exports = __webpack_public_path__ + "64f0d2d7a590e22c8d0c415ba7d729af.svg";